import React from 'react';
import Clients from '../components/Clients';
import Cta from '../components/Cta';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import Portfolio from '../components/Portfolio';
import Services from '../components/Services';
import Testimonial from '../components/Testimonail';
import Service from '../components/Service2';


const Home = () => {
    return (
        <>
            <Hero />
            <Intro />
            <Service/>
            <Services />
            <Portfolio />
            <Clients />
            <Testimonial/>
            <Cta/>
            <Footer />
        </>

    )
}

export default Home;

